import React, { useState, useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import ListGroup from 'react-bootstrap/ListGroup';
import { ObjModal } from '../../../../contexts';
import AddReferral from '../../../Modals/AddReferral';
import { DataGridPro, GridActionsCellItem, GridFooterContainer } from '@mui/x-data-grid-pro';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';


const Business = ( { aid, uid, opps, loans } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );
    const [ refData, setRefData ] = useState( [] );
    const [ baData, setBAData ] = useState( [] );
    const [ laData, setLAData ] = useState( [] );

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'referral':
                setModal( <AddReferral /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    let refCols = [
        { field: 'name', headerName: 'Lead', flex: 1, renderCell: ( { row } ) => (
            <Link to={`/contact/${row.id}`}>{row.firstname} {row.lastname}</Link>
        ), valueGetter: ( { row } ) => `${row.firstname} ${row.lastname}` },
        { field: 'firstLead', headerName: 'Orig Opp', type: 'date', width: 100, valueFormatter: ( { value } ) => value && new Date( value + 'T12:00:00.000' ).toLocaleDateString() },
        { field: 'lastLead', headerName: 'Latest Opp', type: 'date', width: 100, valueFormatter: ( { value } ) => value && new Date( value + 'T12:00:00.000' ).toLocaleDateString() },
        { field: 'count', headerName: '# Opps', type: 'number', width: 60 }  
    ];
    let loanCols = [
        { field: 'name', headerName: 'Loan', flex: 1, renderCell: ( { row } ) => (
            <Link to={`/loan/${row.id}`}>{row.name}</Link>
        ), valueGetter: ( { row } ) => row.name },
        { field: 'status', headerName: 'Status', width: 100 },
        { field: 'amount', headerName: 'Amount', width: 100 },
        { field: 'purpose', headerName: 'Purpose', width: 75 }  
    ];

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    useEffect( () => {
        setExpanded( obj.referrals.length > 0 || obj.ba.length > 0 || obj.la.length > 0 );

        let list = [];
        if ( obj.referrals.length ) {
            obj.referrals.forEach( r => {
                list.push( {
                    id: r.cid,
                    firstname: r.firstname,
                    lastname: r.lastname,
                    firstLead: r.leadDateFirst,
                    lastLead: r.leadDateLast,
                    count: r.leadCount
                } );
            } );
        }
        setRefData( list );

        list = [];
        if ( obj.ba.length ) {
            obj.ba.forEach( l => {
                list.push( {
                    id: l.lid,
                    name: l.name,
                    purpose: l.purpose,
                    amount: l.amount,
                    status: l.status
                } );
            } );
        }
        setBAData( list );

        list = [];
        if ( obj.la.length ) {
            obj.la.forEach( l => {
                list.push( {
                    id: l.lid,
                    name: l.name,
                    purpose: l.purpose,
                    amount: l.amount,
                    status: l.status
                } );
            } );
        }
        setLAData( list );
    }, [ obj.referrals, obj.ba, obj.la ] );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Business With ({obj.referrals.length})</Typography></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails style={ { maxHeight: '250px', overflowY: 'scroll' } }>
                    <Row className='tf-dashboard-li-container overflow-auto pb-2'>
                        <Tabs defaultActiveKey="referrals" id="tf-contact-details" className="m-0">
                            <Tab eventKey="referrals" title="Referrals">
                                <DataGridPro
                                    rows={refData}
                                    columns={refCols}
                                    disableSelectionOnClick
                                    hideFooter={true}
                                    autoHeight={true}
                                    rowHeight={40}
                                />
                            </Tab>
                            <Tab eventKey="ba" title="Buyer's Agent">
                                <DataGridPro
                                    rows={baData}
                                    columns={loanCols}
                                    disableSelectionOnClick
                                    hideFooter={true}
                                    autoHeight={true}
                                    rowHeight={40}
                                />
                            </Tab>
                            <Tab eventKey="la" title="Listing Agent">
                                <DataGridPro
                                    rows={laData}
                                    columns={loanCols}
                                    disableSelectionOnClick
                                    hideFooter={true}
                                    autoHeight={true}
                                    rowHeight={40}
                                />
                            </Tab>
                        </Tabs>
                    </Row>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    opps: state.leadopps.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Business );